import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Tool } from '@app/shared/utils';
import { AppState } from '@app/store';
import { resetConsultationData } from '@app/store/consultation/consultation.actions';
import { selectConsultationPatient } from '@app/store/consultation/consultation.selectors';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, tap, withLatestFrom } from 'rxjs/operators';
import { resetAllowance, resetAllowanceStepToFirst, setAllowanceStep } from '../actions/allowance-steps.actions';
import { resetProductsState } from '@app/store/products';
import { AppRoutes } from '@app/shared/utils/enums/routes.enum';
import { AllowanceStep } from '@app/pages/allowance/allowance';
import { selectAllowanceParams } from '../selectors/allowance-params.selectors';

@Injectable()
export class AllowanceStepsEffects {
  /**
   * Redirect step effect
   * If route is set it prevails;
   * If patient exist go to profile, force weight-management tab if user created one;
   * Go to homepage for other cases
   */
  redirectStep$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setAllowanceStep),
        filter((action) => action.step === AllowanceStep.Redirect),
        withLatestFrom(this.store$.select(selectAllowanceParams), this.store$.select(selectConsultationPatient)),
        tap(([action, params, patient]) => {
          let route = [''];
          if (params.forcedRedirectRoute) {
            route = [params.forcedRedirectRoute];
          } else if (patient) {
            route = [
              AppRoutes.PATIENT,
              patient.id,
              action.tool === Tool.WeightManagement || params.tool === Tool.WeightManagement ? AppRoutes.WEIGHT : AppRoutes.HEALTH,
            ];
          }
          this.router
            .navigate(route, {
              queryParams: {
                fromAllowance: true,
              },
            })
            .then(() => {
              if (params.resetAfterRedirectStep) {
                this.store$.dispatch(resetAllowance());
                this.store$.dispatch(resetConsultationData());
                this.store$.dispatch(resetProductsState());
              } else {
                this.store$.dispatch(resetAllowanceStepToFirst());
              }
            });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<AppState>,
    private readonly router: Router,
  ) {}
}
